var map = {
	"./adult/pause-btn.svg": 5389,
	"./confidence/pause-btn.svg": 2555,
	"./couples/pause-btn.svg": 1726,
	"./nice/pause-btn.svg": 5116,
	"./psycho/pause-btn.svg": 7507,
	"./quirky/pause-btn.svg": 6452,
	"./rude/pause-btn.svg": 6025,
	"./sex/pause-btn.svg": 7301,
	"./spicy-couple/pause-btn.svg": 7152,
	"./spicy/pause-btn.svg": 7731
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79;